// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StatValueV5",
  "kind": "LinkedField",
  "name": "activePrivate",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "StatValueV5",
  "kind": "LinkedField",
  "name": "activePublic",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ratio",
        "variableName": "__relay_internal__pv__DevicePixelRatio"
      },
      {
        "kind": "Literal",
        "name": "width",
        "value": 60
      }
    ],
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v10 = {
  "alias": "agentProfilePhoto",
  "args": null,
  "concreteType": "ProfilePhoto",
  "kind": "LinkedField",
  "name": "profilePhoto",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChapterDashboardRelayPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChapterDashboardBuyerNeedStats_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChapterDashboardPropertyStats_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChapterDashboardUpcomingShowings_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChapterDashboardBroadcastMessages_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChapterDashboardChapterMembers_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ChapterDashboardRelayPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChapterBuyerNeedStats",
        "kind": "LinkedField",
        "name": "chapterBuyerNeedStats",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatValueV5",
            "kind": "LinkedField",
            "name": "purchased",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChapterPropertyStats",
        "kind": "LinkedField",
        "name": "chapterPropertyStats",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatValueV5",
            "kind": "LinkedField",
            "name": "sold",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShowingsCountV5",
        "kind": "LinkedField",
        "name": "upcomingShowingsCountV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agentsOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buyersWelcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tanOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 3
          },
          {
            "kind": "Literal",
            "name": "interval",
            "value": "COMING_WEEK"
          }
        ],
        "concreteType": "QueryUpcomingShowingsV5Connection",
        "kind": "LinkedField",
        "name": "upcomingShowingsV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryUpcomingShowingsV5ConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ShowingV5",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startDateV2",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endDateV2",
                    "storageKey": null
                  },
                  {
                    "alias": "type_",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForSalePropertyV5",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": "agentV2Id",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "agentV2",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Agent",
                                        "kind": "LinkedField",
                                        "name": "agent",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VisibleForSalePropertyAgent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ForSalePropertyV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": "agentId",
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "RentalPropertyV5",
                            "abstractKey": null
                          }
                        ],
                        "type": "PropertyV5",
                        "abstractKey": "__isPropertyV5"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyLocation",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "address",
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visibilityRule",
                                "storageKey": null
                              }
                            ],
                            "type": "PropertyLocationWithVisibleAddress",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "type": "PropertyLocationWithHiddenAddress",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "upcomingShowingsV5(first:3,interval:\"COMING_WEEK\")"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 4
          }
        ],
        "concreteType": "MessageBroadcastConnection",
        "kind": "LinkedField",
        "name": "messageBroadcasts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageBroadcastEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageBroadcast",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "broadcastAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CategoryV5",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "messageBroadcasts(first:4)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChapterV5",
        "kind": "LinkedField",
        "name": "currentChapterV5",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 8
              }
            ],
            "concreteType": "ChapterV5MembersConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterV5MembersConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "profilePhoto",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "members(first:8)"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "004b617e3b8adf3ad7a9caeeddcdd5ea",
    "id": null,
    "metadata": {},
    "name": "ChapterDashboardRelayPageQuery",
    "operationKind": "query",
    "text": "query ChapterDashboardRelayPageQuery(\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...ChapterDashboardBuyerNeedStats_query\n  ...ChapterDashboardPropertyStats_query\n  ...ChapterDashboardUpcomingShowings_query\n  ...ChapterDashboardBroadcastMessages_query\n  ...ChapterDashboardChapterMembers_query\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment ChapterDashboardBroadcastMessages_message on MessageBroadcast {\n  id\n  subject\n  broadcastAt\n  agent {\n    displayName\n    ...AgentProfilePhoto_agent\n    nodeId\n  }\n  category {\n    name\n  }\n}\n\nfragment ChapterDashboardBroadcastMessages_query on Query {\n  messageBroadcasts(first: 4) {\n    edges {\n      node {\n        id\n        ...ChapterDashboardBroadcastMessages_message\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ChapterDashboardBuyerNeedStats_query on Query {\n  chapterBuyerNeedStats {\n    activePrivate {\n      count\n    }\n    activePublic {\n      count\n    }\n    purchased {\n      count\n    }\n  }\n}\n\nfragment ChapterDashboardChapterMembers_agent on Agent {\n  ...AgentProfilePhoto_agent\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  id\n  displayName\n  firstName\n  lastName\n}\n\nfragment ChapterDashboardChapterMembers_query on Query {\n  currentChapterV5 {\n    displayName\n    memberCount\n    members(first: 8) {\n      edges {\n        node {\n          id\n          ...ChapterDashboardChapterMembers_agent\n          nodeId\n        }\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ChapterDashboardPropertyStats_query on Query {\n  chapterPropertyStats {\n    activePrivate {\n      count\n    }\n    activePublic {\n      count\n    }\n    sold {\n      count\n    }\n  }\n}\n\nfragment ChapterDashboardUpcomingShowingsSingleShowing_showing on ShowingV5 {\n  startDateV2\n  endDateV2\n  type_: type\n  notes\n  property {\n    id\n    ...UseShouldShowPropertyDetails_propertyV5\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithVisibleAddress {\n        address\n        locationDisplay\n        visibilityRule\n      }\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ChapterDashboardUpcomingShowings_query on Query {\n  upcomingShowingsCountV5 {\n    agentsOnly\n    buyersWelcome\n    tanOnly\n    total\n  }\n  upcomingShowingsV5(first: 3, interval: COMING_WEEK) {\n    edges {\n      node {\n        id\n        ...ChapterDashboardUpcomingShowingsSingleShowing_showing\n        nodeId\n      }\n    }\n  }\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
